var map = {
	"./en/btn_99_1.png": "t4CN",
	"./es/btn_99_1.png": "/jqj",
	"./pt/btn_99_1.png": "InHN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2zN3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/btn_99_1\.png$
// module id = 2zN3
// module chunks = 0